export default "__VITE_ASSET__BHsML$Ft__"